import { decomposeColor, recomposeColor, rgbToHex, hslToRgb } from '@mui/material/styles';

export function mix(color1: string, color2: string): string {
  const { values: values1, type: type1 } = decomposeColor(color1);
  const { values: values2, type: type2 } = decomposeColor(color2);

  if (type1 !== type2) {
    throw Error('Cannot mix different color types. Please provide same color type, hex, rgb etc.');
  }

  const isHex = color1.startsWith('#');
  const isHsl = /hsl/.test(type1);

  const newValues = values1;
  for (let i = 0; i < values1.length; i++) {
    // Indexed access is checked under this project's strict settings. A missing channel means
    // the two colours decomposed to different lengths — treat it as 0 rather than NaN, which
    // would silently produce an unreadable colour instead of an obviously wrong one.
    const channel1 = values1[i] ?? 0;
    const channel2 = values2[i] ?? 0;
    const newValue = (channel1 + channel2) / 2;
    // Index 3 is the alpha channel, which is fractional; the rest are whole numbers.
    newValues[i] = i === 3 ? newValue : Math.round(newValue);
  }

  const mixColor = recomposeColor({
    type: type1,
    values: newValues,
  });

  return isHex ? rgbToHex(isHsl ? hslToRgb(mixColor) : mixColor) : mixColor;
}
